<template>
    <div>
        <StageBackgroundWrap :bgImage="backgroundImages[0]">
            <template slot="fixedRatio">
                <!-- <VideoWrap :videoSrc="backgroundImages[0]"/> -->
                <RadarPulse yellow class="radar-1"/>
                <RadarPulse yellow class="radar-2"/>
            </template>
            <template slot="content">
                <StageNavBar
                    prevInactive="true" @click-previous="clickPrevious"
                    nextInactive="false" @click-next="clickNext"
                    :nextContent="titleContent.nextLabel"
                    statsInactive="false" @click-stats="openModal('stats')"
                    galleryInactive="false" @click-gallery="openModal('gallery')"
                    :visible="sequenceComplete"
                />
                <StageTitleBlock 
                    :StageTitle="title"
                    :StageNumber="titleContent.StageNumber"
                    :StageDesc="titleContent.StageDesc"
                    :animRestart="sequenceComplete"
                    @restart-anim="$root.resetBackgroundFader($refs.backgroundFader)"
                />
            </template>
            <div :class="SCENARIO + '_hotspots'" slot="fixedRatio">
                <transition-group name="fade">
                    <HotspotButton
                        v-for="hotspot in hotspot_buttons"
                        :key="hotspot"
                        :data-hotspot-key="hotspot"
                        @click="openModal('hotspot')"
                    />
                </transition-group>
            </div>
        </StageBackgroundWrap>

        <HotspotModal ref="hotspot" :content="hotspots"/>
        <GalleryModal ref="gallery" :content="gallery"/>
        <StatsModal ref="stats" :content="stats"/>

    </div>
</template>

<script>

import StageNavBar from '@/components/stage_components/StageNavBar'
import StageBackgroundWrap from '@/components/stage_components/StageBackgroundWrap'
import StageTitleBlock from '@/components/stage_components/StageTitleBlock'
import GalleryModal from '@/components/modals/GalleryModal'
import StatsModal from '@/components/modals/StatsModal'
import VideoWrap from '@/components/stage_components/VideoWrap'
import HotspotButton from '@/components/stage_components/HotspotButton'
import HotspotModal from '@/components/modals/HotspotModal'
import RadarPulse from '@/components/stage_components/RadarPulse'

export default {
    components: {
        StageNavBar,
        StageBackgroundWrap,
        StageTitleBlock,
        GalleryModal,
        StatsModal,
        VideoWrap,
        // BackgroundFader,
        HotspotButton,
        HotspotModal,
        RadarPulse,
    },
    data() {
        return {
            sequenceComplete: false,
        }
    },
    computed: {
        SCENARIO() { return this.$root.calcIDs().scenario },
        STAGE() { return this.$root.calcIDs().stage },
        title() { return this.$root.scenarioText[this.SCENARIO].title },
        stats() { return this.$root.scenarioStats[this.SCENARIO] },
        gallery() { return this.$root.scenarioGallery[this.SCENARIO] },
        titleContent() { return this.$root.scenarioText[this.SCENARIO][this.STAGE] },
        backgroundImages() { return this.$root.scenarioBg[this.SCENARIO][this.STAGE] },
        hotspots() { return this.$root.scenarioHotspots[this.SCENARIO] },
        hotspot_buttons() { return this.$root.scenarioHotspotButtons[this.SCENARIO].slice() },
    },
    methods: {
        openModal(name, index) {
            this.$refs[name].openModal(
                // finds the array index of the hotspot that matches the data-hotspot-key value
                this.hotspots.findIndex(element => element.ref == event.target.parentNode.dataset.hotspotKey)
            )
        },
        clickPrevious() {
            this.$router.push(this.titleContent.prevRoute)
        },
        clickNext() {
            this.$router.push(this.titleContent.nextRoute)
        },
    },
}
</script>

<style lang="scss" scoped>
.radar-1 {
    top: 22%;
    left: 67.4%;
}
.radar-2 {
    top: 41%;
    left: 63%;
}
</style>
